import { tableHeadDiversifier } from '../../constants';

export const getFlex = (index: number) => {
  const currentHead = tableHeadDiversifier.find((_, i) => i === index);
  return currentHead?.flex || 1;
};
